module.exports = __webpack_public_path__ + "img/img3.feda33a0.svg";